import { render, staticRenderFns } from "./epmallstore.vue?vue&type=template&id=75a6bffb"
import script from "./epmallstore.vue?vue&type=script&lang=js"
export * from "./epmallstore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports